function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './PersonalizablePrimaryHeader.css';
import React from 'react';
import { canUseDOM, get, getColorByTheme, getPageThemeColors } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import { fullWidthStyles } from '../57_HeaderFullWidth/headerFullWidth';
import HeaderMedia from '../57_HeaderMedia/HeaderMedia';
import RouterLink from '../atoms/RouterLink';
import { tealiumClickFunc } from '../../utils/tealium';
const videoWhiteOverlayTime = 750;
const videoFadeTime = 400;
const PersonalizablePrimaryHeader = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const title = get(fields, 'data.item.title.jss');
  const introText = get(fields, 'data.item.introText.jss');
  const fallbackImage = get(fields, 'data.item.fallbackImage');
  const personalizableVideo = get(fields, 'data.item.personalizableVideo');
  const publicationDate = get(personalizableVideo, 'jss.value.createdDate');
  const personalizableImage = get(fields, 'data.item.personalizableImage');
  const isEmptyPersonalizableImage = get(fields, 'data.item.personalizableImage.jss.value.src');
  const videoAnalytics = get(fields, 'data.item.videoAnalytics');
  const contextName = get(fields, 'data.context.name');
  const ctaLink = get(fields, 'data.item.ctaLink.jss.value.href');
  const ctaLabel = get(fields, 'data.item.ctaLabel.jss.value');
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const variables = BackgroundColorHex ? {
    "--m57-personalizable-primary-header-background-color": BackgroundColorHex,
    "--m57-personalizable-primary-header-background-active-color": ActiveColorHex,
    "--m57-personalizable-primary-header-color": ColorHex
  } : {
    "--m57-personalizable-primary-header-background-color": selectedPrimaryColor,
    "--m57-personalizable-primary-header-background-active-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--m57-personalizable-primary-header-color": getColorByTheme(selectedPrimaryColor)
  };
  if (!fields) {
    console.info('PersonalizablePrimaryHeader component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [PersonalizablePrimaryHeader component is empty: please provide data source]");
    }
    return null;
  }

  //composing media data for header media component from the supplied fields and render this media
  //if component is personalized, it can't contain nested placeholders, so we render media directly from the datasource item instead of rendering media placeholder
  const renderMedia = () => {
    let coverImage = isEmptyPersonalizableImage ? personalizableImage : fallbackImage;
    if (!coverImage && pageEditing) {
      return /*#__PURE__*/React.createElement("div", null, "[Header Media: please provide data source or item should have headerImage field.]");
    }
    const mediaItem = {
      image: coverImage,
      video: personalizableVideo,
      name: title ? title.value : '',
      publicationDate: {
        jss: {
          value: publicationDate ? new Date(publicationDate.split('-')).toISOString() : ''
        }
      },
      description: introText ? introText.value : ''
    };
    const mediaFields = {
      data: {
        item: mediaItem,
        videoAnalytics: videoAnalytics
      }
    };
    return /*#__PURE__*/React.createElement(HeaderMedia, {
      fields: mediaFields,
      params: _objectSpread({}, params)
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "header header-generic--primary",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-media"
  }, renderMedia()), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12 header-content__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-content theme-contrast"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-animate__content-bg theme-contrast"
  }), /*#__PURE__*/React.createElement("div", {
    className: "c-content__main header-animation__content"
  }, title && /*#__PURE__*/React.createElement(Text, {
    className: "c-content__title",
    tag: "h1",
    field: title
  }), introText && /*#__PURE__*/React.createElement(Text, {
    className: "c-content__text",
    tag: "p",
    field: introText
  }), ctaLabel && ctaLink && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RouterLink, {
    href: ctaLink,
    className: "btn btn-secondary c-content__btn desktop__link ",
    onClick: () => {
      tealiumClickFunc(params, contextName);
    },
    title: ctaLabel
  }, ctaLabel), /*#__PURE__*/React.createElement(RouterLink, {
    href: ctaLink,
    className: "btn btn-primary mob__link",
    onClick: () => {
      tealiumClickFunc(params, contextName);
    },
    title: ctaLabel
  }, ctaLabel))))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  })))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `header-animation ${commonStyles} ${fullWidthStyles} ${rtl ? rtlStyles : ltrStyles} ${headerImageStyle}`,
    removePaddingHeader: true,
    componentTabIndex: "disabled"
  }, children);
};
export const commonStyles = "covwi60";
export const ltrStyles = "loifk3h";
export const rtlStyles = "rnjpy1i";
export default PersonalizablePrimaryHeader;